import { BASE_INBOX_PATH } from './BASE_INBOX_PATH';
const pathIncludesInboxPath = () => window.location.pathname.includes(BASE_INBOX_PATH);
export { pathIncludesInboxPath as default, pathIncludesInboxPath };